import { render, staticRenderFns } from "./DiagramRecord.vue?vue&type=template&id=5fe588f4&"
import script from "./DiagramRecord.vue?vue&type=script&lang=js&"
export * from "./DiagramRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports